const CheckoutBagItem = {
    baseStyle: {
        itemWrapper: {
            gap: '15px',
            align: 'flex-start',
            marginTop: '9px'
        },
        headingWrapper: {
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'baseline',
            marginBottom: '15px'
        },
        bagLabel: {
            fontFamily: 'cormorant',
            color: 'black.100',
            display: 'flex',
            fontSize: '30px',
            fontWeight: '400',
            lineHeight: 'normal',
            letterSpacing: '0.15px'
        },
        notReturnableLabel: {
            fontFamily: 'body',
            color: 'black.100',
            display: 'flex',
            fontSize: '14px',
            fontWeight: '300',
            lineHeight: '22px',
            letterSpacing: '0.07px'
        },
        editBagLink: {
            color: 'black.100',
            display: 'flex',
            width: 'fit-content',
            fontSize: '16px',
            fontWeight: '300',
            height: 'fit-content',
            margin: '0px !important',
            letterSpacing: '0.07px',
            lineHeight: '25px',
            textDecoration: 'underline',
            textUnderlineOffset: '4px',
            transition: 'color 0.3s ease',
            _hover: {
                color: 'blue.700'
            }
        },
        bagLineItem: {
            width: 'full',
            alignItems: 'flex-start',
            gap: '20px'
        },
        bagLineItemWrapper: {
            gap: '15px',
            maxHeight: '480px',
            overflowY: 'auto'
        },
        bagLineItemDetail: {
            marginTop: '-3px',
            gap: '10px'
        }
    }
}

export default CheckoutBagItem
